<template>
<div class="custom-card">
 <div class="card card-custom card-stretch gutter-b mt-5">
        <!--begin::Widget -->

     <div  class="card-body" v-if="previewParent===true && !categoryList">
         <div class="d-flex justify-content-between flex-column pt-4 h-100">
             <div class="pb-5">
                 <div class="d-flex flex-column flex-center">
                     <div class="" @click="$emit('filteringCategory',category.id)">
                      <span class="">
                        
                          <img v-if="category.category_image" :src="APIURL + '/uploads/category/'+category.category_image" alt="image" class="bg-img-height rounded" />
                          <img v-else src="/images/no-image-500x500.jpg" alt="image" class="bg-img-height rounded" />
                      </span>
                     </div>
                     <a href="#" class="card-title font-weight-bolder text-dark-75 text-hover-primary font-size-h5 m-0 pt-7 pb-3" @click="$emit('filteringCategory',category.id)">{{categoryName(category.name)}}</a>
                     <button class="btn btn-link" id="view-image" v-if="category.category_image" @click="toggleDialog()" >View Image</button>
                     <div class="d-flex">
                         <button type="button" class="btn btn-success btn-elevate btn-pill btn-elevate-air btn-icon" data-toggle="tooltip" title="Products" data-placement="bottom" data-skin="brand" @click="$emit('filteringCategory',category.id)"><i class="flaticon2-box-1"></i>
                         </button>
                         <button v-if = "category.children.length > 0 " type="button" class="btn btn-danger btn-elevate btn-pill btn-elevate-air btn-icon ml-2" data-toggle="tooltip" title="Sub Category"  data-placement="bottom" @click="$emit('subCategories',{category : category, direction : 'fwd'})"><i class="flaticon2-layers"></i>
                         </button>
                     </div>

                 </div>
             </div>
         </div>
     </div>

    <div v-else-if="previewParent===false && categoryList" class="card-body">
            <div class="d-flex justify-content-between flex-column pt-4 h-100">
                <div class="pb-5">
                    <div class="d-flex flex-column flex-center">
                        <div class="" @click="$emit('filteringCategory',categoryList.id)">
                            <span class="">
                                <img v-if="categoryList.category_image" :src="APIURL + '/uploads/category/'+categoryList.category_image" alt="image" class="bg-img-height rounded" />
                                <img v-else src="/images/no-image-500x500.jpg" alt="image" class="bg-img-height rounded" />
                            </span>
                        </div>
                        <a href="#" class="card-title font-weight-bolder text-dark-75 text-hover-primary font-size-h5 m-0 pt-7 pb-3" @click="$emit('filteringCategory',categoryList.id)">{{categoryList.name}}</a>
                        <button class="btn btn-link" id="view-image" v-if="categoryList.category_image" @click="toggleDialog()" >View Image</button>
                        <button type="button" class="btn btn-success btn-elevate btn-pill btn-elevate-air btn-icon" data-toggle="tooltip" title="Products" data-placement="bottom" data-skin="brand" @click="$emit('filteringCategory',categoryList.id)"><i class="flaticon2-box-1"></i>
                        </button>
                    </div>
                </div>
            </div>
    </div>
    <div class="vgs" v-if="dialog">
        <button type="button" id="close-modal"  @click="toggleDialog()"  class="vgs__close"> ×</button>
        <div class="vgs__container">
            <img v-if="category && category.category_image" :src="'/uploads/category/'+category.category_image"  alt="image" class="vgs__container__img"> 
            <img v-else-if="categoryList && categoryList.category_image" :src="'/uploads/category/'+categoryList.category_image"  alt="image" class="vgs__container__img"> 
        </div> 
    </div>
</div>
</div>

</template>
<script setup>
import { ref } from 'vue';
import { defineProps } from 'vue';

const props = defineProps({
  category: {
    type: Object,
    required: false,
  },
  previewParent: {
    type: Boolean,
    required: true,
  },
  categoryList: {
    type: Object,
    required: false,
  }
});

const dialog = ref(false);
const APIURL = import.meta.env.VITE_API_URL;

const categoryName = (name) => {
  name = name.split('-');
  for (let i = 0; i < name.length; i++) {
    if (name[i] !== '') {
      return name[i];
    }
  }
};

const toggleDialog = () => {
  dialog.value = !dialog.value;
};

</script>
<style scoped>

.tooltip {
  position: absolute;
  z-index: 1070;
  display: block;
  margin: 0;
  font-family: Poppins, Helvetica, sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.9rem;
  word-wrap: break-word;
  opacity: 0; }
.custom-card{
    max-width: 300px;
    margin: 0 auto;
    max-height: 475px;
}
.bg-img-height {
    height: 250px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    max-width: 235px;
    cursor: pointer;
}
  .vgs{
    transition: opacity .2s ease;
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    min-height: 100%;
    height: 100vh;
    background-color: rgba(0,0,0,.8);
    display: table;
  }
  .vgs__close{
    color: #fff;
    position: absolute;
    top: 0;
    right: 0;
    background-color: transparent;
    border: none;
    font-size: 25px;
    width: 50px;
    height: 50px;
    cursor: pointer;
    z-index: 999;
  }
  .vgs__container{
    position: absolute;
    overflow: hidden;
    cursor: pointer;
    overflow: hidden;
    max-width: 100vh;
    margin: .5rem auto 0;
    left: .5rem;
    right: .5rem;
    height: 60vh;
    border-radius: 12px;
    background-color: #000;
  }
  .vgs__container__img{
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  img {
  vertical-align: middle;
  border-style: none;
}
</style>
